// Home "Avis": "Lire la suite" on clamped reviews (button shown only when the text overflows)
const initReviews = () => {
  document.querySelectorAll('.home-review-text').forEach((wrapper) => {
    const text = wrapper.querySelector('.card-text')
    const button = wrapper.querySelector('.home-review-more')

    if (!text || !button) {
      return
    }

    const update = () => {
      if (wrapper.classList.contains('is-expanded')) {
        return
      }
      button.hidden = text.scrollHeight <= text.clientHeight + 1
    }

    button.addEventListener('click', () => {
      const expanded = wrapper.classList.toggle('is-expanded')
      button.setAttribute('aria-expanded', expanded)
      button.textContent = expanded ? button.dataset.less : button.dataset.more
    })

    update()
    window.addEventListener('resize', update)
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReviews)
} else {
  initReviews()
}
